import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import styled from "@emotion/styled";
import {css} from "@emotion/core";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { OutboundLink } from "gatsby-plugin-google-analytics";

const HeForSheSection2Background = styled.div`
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.gray_dark};
  font: 20px/28px Roboto;
  @media(min-width:769px){
    margin-bottom: 150px;
    margin-top: 125px;
  }
  @media(max-width:768px){
    padding-bottom: 50px;
    padding-top: 50px;
  }
`

const HeForSheSection2Title = styled.div`
  font: 58px/62px Abril Fatface;
  margin-bottom:35px;
  color: ${props => props.theme.colors.gray_dark};
  min-height: 132px;
  @media(max-width:1199px){
    font: 56px/60px Abril Fatface;
  }
  @media(max-width:767px){
    font: 2.5rem/3rem Abril Fatface;
    margin-bottom:17.5px;
    margin-left: 20px;
  }
`

const FAHeart = styled(FontAwesomeIcon)`
  font-size:1rem;
  color: ${props => props.theme.colors.accent_yellow_hover};
`

const ButtonFill6 = styled(Button)`
  height: 60px;
  color: ${props => props.theme.buttons.primary_button_violet.normal.color} !important;
  background-color: ${props => props.theme.buttons.primary_button_violet.normal.background_color} !important;
  border-color: ${props => props.theme.buttons.primary_button_violet.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props => props.theme.buttons.primary_button_violet.hovered.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.hovered.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.colors.gray_shadow} !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:3px;
    }
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.primary_button_violet.pressed.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.pressed.border_color} !important;
    box-shadow: none !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:3px;
    }
  }
  @media(max-width:968px){
    width:100%;
    margin-bottom:20px;
  }
}
`


const ButtonOutline6 = styled(Button)`
  height: 60px;
  color: ${props => props.theme.buttons.secondary_big_button_violet.normal.color} !important;
  background-color: transparent !important;
  border-color: ${props => props.theme.buttons.secondary_big_button_violet.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props => props.theme.buttons.secondary_big_button_violet.hovered.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.secondary_big_button_violet.hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.buttons.secondary_big_button_violet.normal.shadow} !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:3px;
    }
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.secondary_big_button_violet.pressed.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.secondary_big_button_violet.pressed.border_color} !important;
    box-shadow: none !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:3px;
    }
  }
  @media(min-width:922px){
    margin-left:25px;
  }
  @media(max-width:968px){
    width:100%;
  }
`

export default function HeForSheSection2(props) {
  return (
  <HeForSheSection2Background backgroundColor={props.Background} color={props.TextColor}>

    <img alt="WomenWorks - man and woman looking at laptop illustration" src="/page-he-for-she-section2-img1.jpg" 
                    css={css`
                    @media(max-width:991px){
                      display: none;
                    }
                    @media(min-width:992px){
                      width:calc(614/1440*100vw);
                      left:0;
                      position: absolute;
                    }
                    @media(min-width:1600px){
                      display: none;
                    }
                `}></img>
      <Container>
             <Row>
                <Col xs="12" lg="5">
                <img alt="WomenWorks - man and woman looking at laptop illustration" src="/page-he-for-she-section2-img1.jpg" 
                    css={css`
                    @media(max-width:1599px){
                      display: none;
                    }
                    @media(min-width:1600px){
                      display: block;
                      width:100%;
                    }
                `}></img>
                </Col>
                <Col Col xs="12" lg="7">
                <Row>
                <HeForSheSection2Title>
                  Sign up for Group Mentorship with our male mentors
                </HeForSheSection2Title>
                <Col >
                    <p css={css`margin-bottom:24px;min-height:54px;max-height:216px;`}>
                        Stronger TogetHER program will allow women mentees to connect and learn from successful male colleagues through a variety of programs:
                    </p>
                    <Row >
                    <Col xs="auto" css={css`padding-right:0;`}>
                        <FAHeart icon={faHeart} />
                    </Col>
                    <Col css={css`padding-left:7px;margin-bottom:20px;`}>
                      Inclusion of male mentors into WomenWorks existing program, via <b>Closed Group Mentorship</b>
                    </Col>
                    </Row>
                    <Row >
                    <Col xs="auto" css={css`padding-right:0;`}>
                        <FAHeart icon={faHeart} />
                    </Col>
                    <Col css={css`padding-left:7px;margin-bottom:20px;`}>
                      A series of <b>Masterclass webinars</b> introducing the importance of men’s role in women professional advancement
                    </Col>
                    </Row>
                    <Row >
                    <Col xs="auto" css={css`padding-right:0;`}>
                        <FAHeart icon={faHeart} />
                    </Col>
                    <Col css={css`padding-left:7px;margin-bottom:20px;`}>
                        <b>Podcast</b> with topics related to diversity and inclusion
                    </Col>
                    </Row>
                    <Row >
                    <Col xs="auto" css={css`padding-right:0;`}>
                        <FAHeart icon={faHeart} />
                    </Col>
                    <Col css={css`padding-left:7px;margin-bottom:20px;`}>
                      <b>Opportunity and Vacancy channels</b> for Male Mentors to support, post, and receive interesting opportunities
                    </Col>
                    </Row>
                    <Row>
                    <Col>
                      <OutboundLink target="_blank" rel="noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSeGwQ9gNxGGKxK8xj7y9L331-qHmHnJfBIjAApiWti-0yFTcw/viewform?usp=pp_url&entry.608700988=Closed+Group+Mentorship">
                            <ButtonFill6 variant="outline-warning">
                              Sign up for group mentorship
                            </ButtonFill6>
                      </OutboundLink>
                      <OutboundLink target="_blank" rel="noreferrer" href="https://bit.ly/womenworksmentorsignupnew">
                        <ButtonOutline6 variant="outline-light" css={css`@media(max-width:991px) {width:100%;}`}>
                            Join as a mentor
                        </ButtonOutline6>
                      </OutboundLink>
                    </Col>
                    </Row>
                </Col>
                </Row>
            </Col>
            </Row>
      </Container>
  </HeForSheSection2Background>
  )
}

